module.exports = __webpack_public_path__ + "img/logo_wwf.c0fe73f3.jpg";